export { FinanceIcon } from './finance'
